import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import useAgentStatus from '../../hooks/agentStatus/useAgentStatus';
import useCurrentTicketKey from '../../hooks/ticketDetailPage/useCurrentTicketKey';
import useCurrentTicketStatus from '../../hooks/ticketDetailPage/useCurrentTicketStatus';
import useCallPlugin from '../../hooks/useCallPlugin';
import useUserById, { deriveCustomizedDetailedUser } from '../../hooks/useUserById';

// This component always starts a call for an existing ticket. We need to refactor this when want to start a call which will create a new ticket
export default function CallNowActionButton({ userId }: { userId: string }) {
    const { startACallForExistingTicket } = useCallPlugin();
    const { t } = useTranslation('forms');
    const { t: tStatus } = useTranslation('agentStatus');
    const { data: currentStatus, isLoading: isLoadingCurrentStatus } = useAgentStatus();
    const ticketStatus = useCurrentTicketStatus();
    const { data, isLoading } = useUserById(userId);
    const requester = deriveCustomizedDetailedUser(data);
    const ticketKey = useCurrentTicketKey();
    const phoneNumber = requester?.primaryPhone?.phone;

    let errorMessage = null;
    if (!phoneNumber) {
        errorMessage = t('phone number not present');
    } else if (isLoadingCurrentStatus || !currentStatus) {
        errorMessage = t('agent status not ready');
    } else if (currentStatus?.status.call !== 'ONLINE' && currentStatus?.status.call !== 'ONLINE_OUTBOUND') {
        errorMessage = t('agent status not valid for call action');
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        errorMessage = errorMessage.replace('${STATUS}', tStatus(currentStatus.status.i18n));
    }

    if (errorMessage) {
        return (
            <Tooltip title={errorMessage} placement="right">
                <Button type="link" size="small" style={{ fontSize: 11, paddingRight: 0 }} disabled={true}>
                    {t('call now')}
                </Button>
            </Tooltip>
        );
    }

    const isTicketClosed = ticketStatus === 'Closed';
    return (
        <>
            <Button
                disabled={isLoading || isTicketClosed}
                type="link"
                size="small"
                style={{ fontSize: 11, paddingRight: 0 }}
                onClick={() => startACallForExistingTicket(phoneNumber, ticketKey)}
            >
                {t('call now')}
            </Button>
        </>
    );
}
